// 把views文件夹下的文件自动生成路由
import layout from '@/layout/layout.vue';
const viewsPathList = import.meta.glob(['../*iews/**/*.vue', '!../*iews/**/components/*.vue']);
const SKILLHUB_HOSTS = new Set(['skillhub.platform-aiintegration-dev.baai.ac.cn', 'skillhub.flagos.io']);

const getRootRedirectPath = () => {
    const hostname = window?.location?.hostname?.toLocaleLowerCase?.() || '';
    return SKILLHUB_HOSTS.has(hostname) ? '/SkillHub' : '/Home';
};

const routes: any = [
    { name: '/', path: '/', component: layout, children: [], redirect: getRootRedirectPath },
    { path: '/:pathMatch(.*)*', name: 'NotFound', redirect: '/Home' },
];

Object.keys(viewsPathList).forEach(item => {
    const realKey = item?.replace?.('../views', '')?.replace?.('.vue', '');
    const name = realKey.split('/').slice(-1)[0].toLocaleLowerCase();

    const route = { name, path: realKey, component: viewsPathList[item] };

    // 特殊处理：Events.vue 使用小写路径 /events
    if (realKey === '/Events') {
        route.path = '/events';
    }

    // 特殊处理：MyEventDetail.vue 使用语义化路径 /my-event
    if (realKey === '/MyEventDetail') {
        route.path = '/my-event';
    }

    // 特殊处理：RaceDetailSeason2.vue 使用语义化路径 /race-detail-season2
    if (realKey === '/RaceDetailSeason2') {
        route.path = '/race-detail-season2';
    }

    if (name.toLocaleLowerCase() === 'login') {
        routes.push(route);
    } else if (realKey === '/MeetingDetail') {
        // MeetingDetail 独立页面（不嵌套 layout，不显示 header/footer）
        routes.push({ name: 'meetingDetail', path: '/2026', component: viewsPathList[item] });
    } else if (realKey === '/meeting/tritonNext/detail') {
        // TritonNext 会议详情页：与 MeetingDetail(/2026) 一致，独立页面（不嵌套 layout，不显示全局 header/footer）
        routes.push({ name: 'tritonNextDetail', path: '/2027', component: viewsPathList[item] });
    } else {
        routes[0].children.push(route);
    }
});
console.log(routes);
export const listRouter = routes;
